module.exports = __webpack_public_path__ + "static/media/lose.56fd51fe.mp3";